import React, { memo, useEffect, useState } from 'react';
import firebase from 'firebase';
import Section from '../_section';
import MainTitle from '../main-title';
import Carrossel from '../carrossel';
import BookDetail from '../book-detail';
import Review from '../review';
import OthersTitle from '../others-title';
import OthersBooks from '../others-books';
import HeaderLogo from '../../assets/images/new/header_logo.webp'
import Footer from '../footer';
import songsName from '../../enums/songsName';
import { playSong } from '../../utils/song';
import NoAuthModal from '../noauthmodal'
import { FiMenu } from "react-icons/fi"
import DrawerMenu from '../drawer-menu';
import AboutModal from '../about-modal';
import QuestionsModal from '../questions-modal';
import CallUsModal from "../faleconosco/faleconosco-modal";
import ProfileModal from '../profile-modal';
import PaymentModal from '../payment-modal';
import LoginModal from '../login-modal';
import RegistrationModal from '../registration-modal';
import KnowMoreModal from '../know-more';
import TermsOfUse from '../terms-of-use';
import PrivacyPolicy from '../privacy-policy';
import clsx from 'clsx';
import DownloadAppModal from '../download-app-modal';
import { truncateText } from '../../utils/common';
import imgPassatempos from '../../assets/images/new/passatempo.webp'
import Button from '../button';

const LandingPage = (props) => {
	const [shouldExpand, setShouldExpand] = useState(true)
	const [isOpenSurprise, setIsOpenSurprise] = useState(null);

	const [showNoAuthModal, setShowNoAuthModal] = useState(false);

	const isAppInitialized = props.appState === 'firsttimevisit' || props.appState === 'landingpage' ? true : false;
	const isLandingPage = props.appState === 'landingpage'

	useEffect(() => {
		if (firebase.messaging.isSupported()) {
			if (window.Notification.permission === 'granted') {
				firebase.messaging().getToken().then(hash => {
					if (hash) console.log('HASH: ', hash);
				});
			}
		}
	}, []);

	useEffect(() => {
		if (props.isReading) {
			props.pauseBackgroundSong()
		}
	}, [props, props.appState, props.isReading]);

	// const registerServiceWorker = () => {
	// 	if (firebase.messaging.isSupported()) {
	// 		return navigator.serviceWorker.register('/firebase-messaging-sw.js');
	// 	}
	// }

	if (!isAppInitialized) {
		return <div />;
	}

	const changeReader = props.changeReader;

	const onChangeReader = (props) => {
		playSong(songsName.TAP)
		changeReader(props)
	}

	const showExpanded = () => {
		setShouldExpand(true)
	}

	const showLoginModal = () => {
		setShowNoAuthModal(true)
	}

	const getGreetingMessage = () => {
		if (!props.isLoggedIn) return ""

		if (props?.subscriberData?.nome && props?.subscriberData?.nome !== 'undefined' && props?.subscriberData?.nome !== 'null') {
			const firstName = props?.subscriberData?.nome.split(' ')[0]
			return `Olá, ${truncateText(firstName, 10)}`
		}

		return `Olá, navegante!`
	}

	return (
		<>
			{/* <PushNotificationModal showEnable={props.appState === 'landingpage'} /> */}

			<Section parent={props}>
				{props.appState === 'landingpage' ? (
					<div
						className={clsx(`header w-full max-w-5xl flex flex-row justify-between items-center pb-4 px-6 bg-blue-400 shadow-md z-30`)}
						style={{ paddingTop: window.native_app_status_bar_height ?? 16, paddingBottom: 7 }}
					>
						<div className='flex flex-1 flex-row items-center'>
							<button onClick={props.openDrawerHandler}>
								<FiMenu className='w-8 h-8 text-green-secondary' />
							</button>

							<h1 className="font-bold text-sm text-gray-secondary ml-auto mr-4">
								{getGreetingMessage()}
							</h1>
						</div>

						<img src={HeaderLogo} alt='Logo' className='h-12' />
					</div>
				) : null}

				<DrawerMenu
					isOpened={props.isDrawerOpened}
					close={props.closeDrawerHandler}
					openLoginModal={props.openLoginModalHandler}
					openRegistrationModal={props.openRegistrationModalHandler}
					openAboutModal={props.openAboutModalHandler}
					openQuestionsModal={props.openQuestionsModalHandler}
					openContactUsModal={props.openContactUsModalHandler}
					openProfileModal={props.openProfileModalHandler}
					openPaymentModal={props.openPaymentModalHandler}
					openTermsOfUseModal={props.openTermsOfUseModalHandler}
					openPrivacyPolicyModal={props.openPrivacyPolicyModalHandler}
					openKnowMore={props.openKnowMore}
					logout={props.logout}
					isLoggedIn={props.isLoggedIn}
					isSongDisabled={props.isSongDisabled}
					hasUserASubscription={props.hasUserASubscription}
					toggleBackgroundSong={props.toggleBackgroundSong}
					loginProvider={props.loginProvider}
				/>

				{
					window.is_tablet ? (
						<div style={{ height: 16 }} />
					) : (
						<div
							style={{
								height: window.native_app_status_bar_height ?? 24
							}}
						/>
					)
				}
				<MainTitle
					isLoggedIn={props.isLoggedIn}
					isOpenSurprise={isOpenSurprise}
					setIsOpenSurprise={setIsOpenSurprise}
					subscriberData={props.subscriberData}
				/>
				<Carrossel
					isOpenSurprise={isOpenSurprise}
					setIsOpenSurprise={setIsOpenSurprise}
					changeToLandingPage={props.changeToLandingPage}
					changeReader={onChangeReader}
					offlineBooksIds={props.offlineBooksIds}
					showExpanded={showLoginModal}
					isLoggedIn={props.isLoggedIn}
					openingBookId={props.openingBookId}
					loginProvider={props.loginProvider}
					hasUserASubscription={props.hasUserASubscription}
				/>
				<BookDetail
					handleOpenReader={props.handleOpenReader}
					changeReader={onChangeReader}
					downloadBook={props.downloadBook}
					offlineBooksIds={props.offlineBooksIds}
					downloadingBooksIds={props.downloadingBooksIds}
					showExpanded={showExpanded}
					showLoginModal={showLoginModal}
					isLoggedIn={props.isLoggedIn}
					openingBookId={props.openingBookId}
					loginProvider={props.loginProvider}
					hasUserASubscription={props.hasUserASubscription}
					playBackgroundSong={props.playBackgroundSong}
					pauseBackgroundSong={props.pauseBackgroundSong}
				/>
				<Review />

				<div className='content-wrapper'>
					{props.showGameBanner ? (
						<div
							className='passatempos-banner-wrapper'
							onClick={() => {
								playSong(songsName.TAP)
								window.scrollTo(0, 0);
								props.openGames()
							}}
						>
							<span className='text-white font-bold text-2xl absolute top-12 left-1/2 -translate-x-1/2 transform uppercase'>Passatempos</span>
							<img className='passatempos-banner' src={imgPassatempos} alt='passatempos' />
							<Button
								onClick={() => {
									playSong(songsName.TAP)
									window.scrollTo(0, 0);
									props.openGames()
								}}
								className="w-32 absolute bottom-28 left-1/2 -translate-x-1/2 transform normal-case"
							>
								Divirta-se
							</Button>

						</div>
					) : <div />}

					<OthersTitle />
					<div
						className='footer-wrapper'
						style={{
							paddingBottom: window.native_app_navigation_bar_height ?? 0
						}}
					>
						<OthersBooks
							downloadBook={props.downloadBook}
							offlineBooksIds={props.offlineBooksIds}
							downloadingBooksIds={props.downloadingBooksIds}
							lastDownloadedBooksIds={props.lastDownloadedBooksIds}
							openBookFromDownloaded={props.openBookFromDownloaded}
							isLoggedIn={props.isLoggedIn}
							openingBookId={props.openingBookId}
							removeDownloadedBook={props.removeDownloadedBook}
							loginProvider={props.loginProvider}
							hasUserASubscription={props.hasUserASubscription}
							showExpanded={showExpanded}
						/>

						{/* <InfoButtons appState={props.appState} changeToLogin={props.changeToLogin} /> */}
						{/* <InfoSmallButtons /> */}
						<Footer />
					</div>
				</div>

				<NoAuthModal
					open={showNoAuthModal}
					changeToLogin={props.openLoginModalHandler}
					onClose={() => setShowNoAuthModal(false)}
				/>

				{
					isLandingPage ? (
						<>
							<ProfileModal isOpened={props.showProfileModal} close={props.closeProfileModalHandler} backToDrawerMenu={props.backToDrawerMenu} subscriberData={props.subscriberData} logout={props.logout} />
							<PaymentModal subscriptionData={props.subscriptionData} isOpened={props.showPaymentModal} close={props.closePaymentModalHandler} backToDrawerMenu={props.backToDrawerMenu} hasUserASubscription={props.hasUserASubscription} checkIfUserHasScubscription={props.checkIfUserHasScubscription} subscriberData={props.subscriberData} isUserInFreeTrial={props.isUserInFreeTrial} />
							<AboutModal isOpened={props.showAboutModal} close={props.closeAboutModalHandler} backToDrawerMenu={props.backToDrawerMenu} />
							<QuestionsModal isOpened={props.showQuestionsModal} close={props.closeQuestionsModalHandler} backToDrawerMenu={props.backToDrawerMenu} />
							<KnowMoreModal isOpened={props.showKnowMore} close={props.closeKnowMore} backToDrawerMenu={props.backToDrawerMenu} />
							<TermsOfUse isOpened={props.showTermsOfUse} close={props.closeTermsOfUseModalHandler} backToDrawerMenu={props.backToDrawerMenu} />
							<PrivacyPolicy isOpened={props.showPrivacyPolicy} close={props.closePrivacyPolicyModalHandler} backToDrawerMenu={props.backToDrawerMenu} />

							<LoginModal isOpened={props.showLoginModal} registrationEmail={props.registrationEmail} close={props.closeLoginModalHandler} openRegistration={props.openRegistrationFromLoginModal} onLoginSuccess={props.onLoginSuccess} onPortfolioLoaded={props.onPortfolioLoaded} updateSubscriberData={props.updateSubscriberData} updateLoginProvider={props.updateLoginProvider} backToDrawerMenu={props.backToDrawerMenu} />
							<RegistrationModal isOpened={props.showRegistrationModal} close={props.closeRegistrationModalHandler} openLogin={props.openLoginFromRegistrationModal} backToDrawerMenu={props.backToDrawerMenu} />

							<CallUsModal
								show_callus={props.showContactUsModal}
								toggle_callus={props.closeContactUsModalHandler}
								appState={props.appState}
								backToDrawerMenu={props.backToDrawerMenu}
							/>
						</>
					) : null
				}

				<DownloadAppModal
					opened={shouldExpand}
					close={() => setShouldExpand(false)}
				/>

				{/* <AdsModal
					open={showAdsModal}
					onRequestClose={setShowAdsModal}
					changeToLandingPage={props.changeToLandingPage}
				/> */}
			</Section>
		</>
	);
};

export default memo(LandingPage);
